// Copyright 2024 Sorama B.V.

export class ResponseMock {
    private defaultDelay: number;
    private defaultFailRate: number;
    private defaultError: Error;

    constructor(defaultFailRate = 0, defaultDelay = 1, defaultError: Error = new Error("Mock error")) {
        this.defaultDelay = defaultDelay;
        this.defaultFailRate = defaultFailRate;
        this.defaultError = defaultError;
    }

    respond<T>(
        response?: T,
        delay: number = this.defaultDelay,
        failRate: number = this.defaultFailRate,
        error: Error = this.defaultError
    ): Promise<T> {
        return new Promise((resolve, reject) =>
            setTimeout(() => {
                Math.random() < failRate ? reject(error) : resolve(response);
            }, delay * 1000)
        );
    }

    fail<T>(error: Error = this.defaultError, delay: number = this.defaultDelay): Promise<T> {
        return new Promise<T>((resolve, reject) =>
            setTimeout(() => {
                reject(error);
            }, delay * 1000)
        );
    }
}
